import {AfterViewChecked, Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import { Response } from '@angular/http';
import { Router } from '@angular/router';
import {  AlertService } from 'ng-jhipster';
import { Master } from './master.model';
import { MasterService } from './master.service';
import { Principal } from '../../shared';
import {isNullOrUndefined} from 'util';
import {CampaignService} from '../campaign/campaign.service';
import { Subscription } from 'rxjs';
import { UtilsService } from '../../shared/utils/utils.service';

@Component({
    selector: 'jhi-master',
    templateUrl: './master.component.html'
})
export class MasterComponent implements OnInit, AfterViewChecked, OnDestroy {
    masters: Master[];
    currentAccount: any;
    multiSortMeta: any[];
    @ViewChild('dt') dt;
    initialized: boolean;
    userAcademyLabel: string;
    userAcademicRegionLabel: string;

    private subscription: Subscription = new Subscription();

    constructor(
        private masterService: MasterService,
        private alertService: AlertService,
        private principal: Principal,
        private router: Router,
        private campaignService: CampaignService,
        public utilsService: UtilsService
    ) {
    }

    loadAll(campaign: string) {
        this.subscription.add(this.masterService.query({'campaign': campaign}).subscribe(
            (res: Response) => {
                this.masters = res.json();
            },
            (res: Response) => this.onError(res.json())
        ));
    }

    ngOnInit() {
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.loadAll(this.campaignService.getDisplayedCampaign());
        this.userAcademyLabel = this.principal.getAcademyLabel();
        this.userAcademicRegionLabel = this.principal.getAcademicRegionLabel();
    }

    onStateChanged() {
        if (!isNullOrUndefined(this.dt) && !isNullOrUndefined(this.dt.multiSortMeta)) {
            localStorage.setItem('mastersSort', JSON.stringify(this.dt.multiSortMeta));
        }
        if (!isNullOrUndefined(this.dt) && !isNullOrUndefined(this.dt.filters)) {
            localStorage.setItem('mastersFilters', JSON.stringify(this.dt.filters));
        }
        if (!isNullOrUndefined(this.dt) && !isNullOrUndefined(this.dt.first)) {
            sessionStorage.setItem('mastersPage', JSON.stringify(this.dt.first));
        }
    }

    paginate() {
        if (!isNullOrUndefined(this.dt) && !isNullOrUndefined(this.dt.first)) {
            sessionStorage.setItem('mastersPage', JSON.stringify(this.dt.first));
        }
    }

    ngAfterViewChecked() {
        if ( this.dt && !this.initialized ) {
            // wait a tick to avoid one-time devMode
            // unidirectional-data-flow-violation error
            setTimeout(_ => this.onLoad());
            this.initialized = true;
        }
    }

    onSelectMaster(dt, master: Master) {
        this.router.navigate(['../masters', master.id]);
    }

    // restaure soit un filtre sauvegardé soit un filtre associe au profil
    onLoad() {
        let filtersLocalStorage = JSON.parse(localStorage.getItem('mastersFilters'));
        let sortLocalStorage = JSON.parse(localStorage.getItem('mastersSort'));
        let pageSessionStorage = Number(sessionStorage.getItem('mastersPage'));
        if (sortLocalStorage) {
            this.multiSortMeta = sortLocalStorage;
        } else {
            this.loadDefaultSort();
        }
        if (filtersLocalStorage) {
            this.dt.filters = filtersLocalStorage;
        } else {
            this.loadDefaultFilters();
        }
        this.applyTableState(pageSessionStorage);
    }

    loadDefaultFilters() {
        this.dt.reset();
        this.dt.filters['masterInm'] = {matchMode: 'contains', value: '' };
        this.dt.filters['formationLabel'] = {matchMode: 'contains', value: '' };
        this.dt.filters['masterSchoolName'] = {matchMode: 'contains', value: '' };
        this.dt.filters['residualVacantPlaces'] = {matchMode: 'contains', value: '' };
        this.dt.filters['attributedPlaces'] = {matchMode: 'contains', value: '' };
        this.dt.filters['availablePlaces'] = {matchMode: 'contains', value: '' };
        this.dt.filters['residualVacantPlacesLastModificationDate'] = {matchMode: 'contains', value: '' };
        this.dt.filters['academyLabel'] = {matchMode: 'contains', value: '' };
        this.dt.filters['academicRegionLabel'] = {matchMode: 'contains', value: '' };

        if (this.principal.hasSyncAuthority('ROLE_ACADEMICREGIONRECTOR')) {
            this.dt.filters['academicRegionLabel'] = {matchMode: 'contains', value: this.userAcademicRegionLabel };
        }
        if (this.principal.hasSyncAuthority('ROLE_ACADEMICRECTOR')) {
            this.dt.filters['academyLabel'] = {matchMode: 'contains', value: this.userAcademyLabel };
        }
    }

    loadDefaultSort(): void {
        if (this.principal.hasSyncAuthority('ROLE_SCHOOL_ADMIN')) {
            this.multiSortMeta = [];
            this.multiSortMeta.push({field: 'formationLabel', order: 1});
        }
        if (this.principal.hasSyncAuthority('ROLE_ACADEMICREGIONRECTOR')) {
            this.multiSortMeta = [];
            this.multiSortMeta.push({field: 'academyLabel', order: 1});
            this.multiSortMeta.push({field: 'masterSchoolName', order: 1});
            this.multiSortMeta.push({field: 'formationLabel', order: 1});
        }
        if (this.principal.hasSyncAuthority('ROLE_ACADEMICRECTOR')) {
            this.multiSortMeta = [];
            this.multiSortMeta.push({field: 'academicRegionLabel', order: 1});
            this.multiSortMeta.push({field: 'academyLabel', order: 1});
            this.multiSortMeta.push({field: 'formationLabel', order: 1});
        }
    }

    reapplyDefaultTableState(): void {
        if (this.initialized) {
            this.loadDefaultSort();
            this.loadDefaultFilters();
            this.applyTableState(0);
        }
    }

    applyTableState(page) {
        this.dt.multiSortMeta = this.multiSortMeta;
        if (this.dt.multiSortMeta && Array.isArray(this.dt.multiSortMeta) && this.dt.multiSortMeta.length) {
            this.dt.sortMultiple();
        } else {
            this.dt._filter();
        }
        setTimeout(_ => this.setPage(page ? page : 0));
    }

    setPage(page) {
        let paging = {
            first: page,
            rows: this.dt.rows
        };
        this.dt.paginate(paging);
    }

    private onError (error) {
        this.alertService.error(error.message, null, null);
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master/master.component.ts